import styled, { css } from "styled-components";
import { NavLink } from "react-router-dom";

import { MenuElement } from "../common-style";
import { StyledStaffLines } from "../StaffLines";
import { IDarkModeButtonStyleProps } from "./interfaces";
import { IStyleProps } from "../interfaces";

export const StyledNavRight = styled.div`
    transition: transform 400ms, opacity 400ms;
    justify-content: flex-end;
    display: flex;
    flex: 1;
    padding-right: 16px;
    opacity: 1;
`;

export const MenuItem = styled(NavLink)<IStyleProps>`
    ${MenuElement}
`;

export const DarkModeButton = styled.div<IDarkModeButtonStyleProps>`
    position: relative;
    display: flex;
    align-items: center;
    margin: 4px;
    cursor: pointer;

    svg {
        transition: fill 0.2s;
        fill: ${p => p.theme.c.dark};
    }

    @media screen and (max-width: 340px) {
        display: none;
    }
    &:hover {
        color: ${p => p.theme.c.pale};

        svg {
            fill: ${p => p.theme.c.pale};
        }
    }

    ${p =>
        p.isActive
            ? css`
                  svg {
                      fill: ${p => p.theme.c.snowOnActive} !important;
                  }
                  &:hover {
                      svg {
                          fill: ${p => p.theme.c.snowOnActive};
                      }
                  }
              `
            : undefined}
`;

export const StyledLogin = styled.div<IStyleProps>`
    ${MenuElement}
`;

export const StyledStaffLinesRight = styled.div`
    ${StyledStaffLines}
    position: absolute;
    right: auto;
    transition: opacity 400ms;
    ${p =>
        p.theme.lg(css`
            left: calc(${p => p.theme.$screenLg}px - 15px - 12px - 11px);
        `)}
    ${p =>
        p.theme.md.only(css`
            left: calc(${p => p.theme.$screenMd}px - 15px - 12px - 11px);
        `)}
    ${p =>
        p.theme.sm.only(css`
            left: calc(${p => p.theme.$screenSm}px - 15px - 12px - 11px);
        `)}
    ${p =>
        p.theme.xs(css`
            left: calc(100vw - ${12 + 11}px);
        `)}
    top: 0;
    pointer-events: none;

`;

export const StaffLinesRightStart = styled.svg`
    position: absolute;
    top: 0;
    left: 0;
    width: 23px !important;
    height: 100%;

    rect,
    circle {
        fill: ${p => p.theme.c.snowOnActive};
    }
`;

export const $userDimension = 30;
export const UserImage = styled.div`
    border-radius: ${$userDimension / 2}px;
    overflow: hidden;
    width: ${$userDimension}px;
    height: ${$userDimension}px;
    margin-right: 12px;
    box-sizing: border-box;

    .i-user {
        font-size: ${$userDimension}px;
        color: ${p => p.theme.c.dark};
    }

    img {
        width: ${$userDimension}px;
        height: ${$userDimension}px;
    }
`;

export const Usermenu = styled.div`
    position: absolute;
    top: calc(100% + 4px);
    right: -12px;
    background-color: ${p => p.theme.c.boost};
    text-align: left;
    padding: 10px 6px;
    box-sizing: border-box;
    box-shadow: 0 0 5px 0 ${p => p.theme.c.blackShadow3};
    overflow-y: auto;
    cursor: default;
    border-radius: 0 0 8px 8px;
`;

export const UserName = styled.div`
    display: inline-block;
    max-width: 100px;
    overflow: hidden;
    text-overflow: ellipsis;
    margin-right: 10px;
`;

export const UserMenuItem = css`
    margin-bottom: 6px;
    height: 28px;
`;

const showUserMenuText = css`
    ${p =>
        p.theme.sm.only(css`
            span:not([class^="i-"]) {
                display: block !important;
            }
        `)}
`;

export const Account = styled(MenuItem)`
    ${UserMenuItem}
    ${showUserMenuText}
    white-space: nowrap;
    padding-right: 6px;
    margin-top: 0;
`;

export const Logout = styled.div<IStyleProps>`
    ${MenuElement}
    ${UserMenuItem}
    ${showUserMenuText}
    margin-bottom: 0;
`;

export const MobileMenuOpener = styled.div`
    ${p =>
        p.theme.sm.min(css`
            display: none;
        `)}

    margin-top: 2px;
    padding: 12px;
    display: flex;
    cursor: pointer;
    align-items: center;

    > div {
        height: 20px;
    }

    .Line {
        width: 21px;
        margin-top: 4px;
        height: 3px;
        background-color: ${p => p.theme.c.dark};
        transition: 0.3s;

        &.Line1 {
            margin-top: 0;
        }
    }

    .Active {
        .Line1 {
            transform: rotate(-45deg) translate(-4.7px, 5.2px) scale(1.24, 1);
        }

        .Line2 {
            transform: scale(0, 1);
        }

        .Line3 {
            transform: rotate(45deg) translate(-4.7px, -5.2px) scale(1.24, 1);
        }
    }
`;
export const NotificationCount = styled.div`
    background-color: ${p => p.theme.c.wrong};
    position: absolute;
    bottom: 4px;
    right: -2px;
    width: 12px;
    height: 12px;
    border-radius: 8px;
    color: ${p => p.theme.c.snow};
    font-size: 10px;
    line-height: 13px;
    text-align: center;
    font-family: arial, serif;
    font-weight: 300;
`;

export const SmallIcon = styled.div`
    display: inline-block;

    svg,
    [class^="i-"] {
        width: 28px;
        height: 28px;
        font-size: 28px;
        display: block;
        margin-right: 2px;
    }
`;

export const StyledNotification = styled.div<IStyleProps>`
    ${MenuElement}
    ${p =>
        p.theme.xs(css`
            display: flex;
        `)}

    &.Active {
        svg {
            fill: ${p => p.theme.c.white};
        }
    }
`;

export const User = styled.div<IStyleProps>`
    ${MenuElement}
    color: ${p => p.theme.c.snowOnActive};
    margin-right: 12px;

    &:hover {
        svg {
            fill: ${p => p.theme.c.dark};
        }

        .Caret {
            svg {
                fill: ${p => p.theme.c.pale};
            }
        }
    }
`;

export const Caret = styled.div`
    margin-left: -2px;
`;